import { render, staticRenderFns } from "./EmptyProject.vue?vue&type=template&id=e81fc1a4&scoped=true&"
import script from "./EmptyProject.vue?vue&type=script&lang=js&"
export * from "./EmptyProject.vue?vue&type=script&lang=js&"
import style0 from "./EmptyProject.vue?vue&type=style&index=0&id=e81fc1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81fc1a4",
  null
  
)

export default component.exports